import Raf from "quark-raf";

const defaultTween = {
  from: 0,
  to: 1,
  duration: 300,
  onProgress: () => {},
  onComplete: () => {},
}

function easeOut(progress, power = 2) {
  return 1 - (1 - progress) ** power;
}

export default class Tween {

  constructor({to, from, duration, onProgress, onComplete} = defaultTween) {
    this.to = to
    this.from = from
    this.delta = to - from
    this.duration = duration
    this.onProgress = onProgress
    this.onComplete = onComplete

    // bind
    this._update = this._update.bind(this)
    this.start = this.start.bind(this)
    this.stop = this.stop.bind(this)
  }

  start() {
    if (this.isPlaying) return
    this.isPlaying = true
    this.startTime = performance.now();
    Raf.add(this._update);
  }

  stop() {
    if (!this.isPlaying) return
    this.isPlaying = false
    Raf.remove(this._update);
  }

  _update() {
    const dateNow = performance.now()
    const elapsed = dateNow - this.startTime
    const progress = Math.min(elapsed / this.duration, 1);
    const latest = this.from + easeOut(progress) * this.delta;

    this.onProgress?.(latest);

    if (progress >= 1) {
        this.stop()
        this.onComplete?.()
    }
  }
}